export const colors = {
  primary: "#0096A5",
  secondary: "#0096A5",
  red: "#A30236",
  white: "#ffffff",
  black: "#0E100F",
};
